import React, { Component } from 'react';
import Checkbox from './Checkbox';
import Dropdown from './Dropdown';
import Spinner from './Spinner';
import {countriesOptions} from '../config/options'; 

class MobileCart extends Component {

    constructor(){
        super()
        this.state = {
            displayMode:0,
            clientInformationEntered:0,
            selectedObject: 0
        }

        this.selectObject = this.selectObject.bind(this);
        this.saveAndBack = this.saveAndBack.bind(this);
        this.setClientInformation = this.setClientInformation.bind(this);
        this.saveClientInformation = this.saveClientInformation.bind(this);
        this.onDeleteItem = this.onDeleteItem.bind(this);
    }

    selectObject(item){ 
        const itemId = item.target.attributes.getNamedItem('item').value;
        this.setState({selectedObject: itemId});
    }

    saveAndBack(){
        this.setState({selectedObject: 0});
    }

    setClientInformation(){
        this.setState({
            displayMode:1
            
        })
    }

    saveClientInformation(){
        this.setState({
            displayMode:0,
            clientInformationEntered:1
        })
    }

    onDeleteItem(obj){
        this.props.onDeleteItem(obj);
        this.saveAndBack();
    }

    render(){
        if(this.state.displayMode === 0){
            let totalCartAmt = 0; 
            const items = this.props.items.map(
                (itm, i)=>{

                    //display only selected room
                    if(this.state.selectedObject !== 0 && this.state.selectedObject*1 !== i*1){
                        return false;
                    }

                    let curent_price = 0;
                    if(itm.object.numbeds*1 === 1){
                        if(itm.object.bedsize === 'double' || itm.object.bedsize === 'kingsize'){
                            if(itm.numPersons*1 === 1){
                                curent_price = itm.object.price_1
                            }else{
                                curent_price = itm.object.price;
                            }
                        }else{
                            curent_price = itm.object.price;
                        }
                    }else if(itm.object.numbeds*1 === 2){
                        if(itm.numPersons*1 === 1){
                            curent_price = itm.object.price_1
                        }else{
                            curent_price = itm.object.price;
                        }
                    }else{
                        if(itm.object.numbeds*1 === itm.numPersons*1){
                            curent_price = itm.object.price;
                        }else{
                            if(itm.numPersons*1 === 1){
                                curent_price = itm.object.price_1;                   
                            }else if(itm.numPersons*1 === 2){
                                curent_price = itm.object.price_2;
                            }else if(itm.numPersons*1 === 3){
                                curent_price = itm.object.price_3;
                            }else{
                                curent_price = itm.object.price;
                            }             
                        }            
                    }    
                    const additionalPrice = itm.earlyCheckIn*itm.object.earlycheckin + 
                                        itm.lateCheckOut*itm.object.latecheckout +
                                        itm.breakfast*itm.numbreakfast*itm.object.breakfastprice +
                                        itm.dinner*itm.numdinner*itm.object.dinnerprice;
                    const numNights  = itm.dateInterval ? Math.round(itm.dateInterval / 86400 / 1000) : 1;
                    const total = (curent_price - (itm.promocode ? itm.object.promodiscount : 0) + additionalPrice) * numNights;
                    totalCartAmt+=total;

                    //guests names
                    let guests = [];                
                    for(let j=0; j<itm.numPersons; j++){
                        let guestFirstName = '';
                        let guestLastName = '';
                        if(itm.guests !== undefined){
                            if(itm.guests[j] !== undefined){
                                guestFirstName = itm.guests[j].FirstName;
                                guestLastName = itm.guests[j].LastName;
                            }
                        }
                        guests[j] = <div className="vb-inputV2" key={i+'-'+j}>
                                    <input type="text" defaultValue={guestFirstName} placeholder="First Name" item={i} guest={j} onBlur={this.props.onChangeGuestFirstName}/>
                                    <input type="text" defaultValue={guestLastName} placeholder="Last Name" item={i} guest={j} onBlur={this.props.onChangeGuestLastName}/>
                                </div>
                    }
                    if(this.state.selectedObject){
                        return (
                            <div className="vb-OrderItemsBlock"  key={i}>
                                <div className="vb-PhotoItems" style={{'backgroundImage': 'url("'+itm.object.photos[0]+'")'}}></div>
                                <div className="vb-content">
                                    <h2>{itm.object.name}</h2>
                                    <p>All our rates include service & taxes{itm.object.breakfast ? ', Scandinavian breakfast' : ''}{itm.object.wifi ? ', free WiFi' : ''}</p>
                                    <div className="vb-size">Roomsize: <span>{itm.object.roomsize} m<sup>2</sup></span></div>
                                    <div className="vb-size">Bedsize: <span>{itm.object.numbeds} {itm.object.bedsize} bed{itm.object.numbeds > 1 ? 's': ''}</span></div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="vb-BookingDate">
                                    <h2>Booking date</h2>
                                    <div>
                                        <p><span className="icon-calendar-brown1"></span> {itm.dateInterval.start.format("MM/DD/YYYY")} - {itm.dateInterval.end.format("MM/DD/YYYY")}</p>                                        
                                    </div>
                                </div>

                                <div className="vb-PersonV2">
                                    <div className="vb-order-open">
                                        <div className="vb-order-info">
                                            <div className="vb-top-border">
                                                <div className="vbmobile-info-content-persons">
                                                    <h2>Persons</h2>
                                                    <div>
                                                    <Spinner value={itm.numPersons} onChange={this.props.onUpdatePersons} item={i}/> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="vb-BlockInputs">
                                {guests}
                                </div>

                                <div className="vb-blockNotes">
                                    <h2>Notes</h2>
                                    <div className="vb-inputV2">
                                        <input type="text" defaultValue={typeof itm.guestNotes !== 'undefined' ? itm.guestNotes : ''} placeholder="Notes" item={i} onChange={this.props.onChangeGuestNotes}/>
                                    </div>
                                </div>
                                
                                <div className="vb-order-open">
                                    {(itm.object.breakfastprice || itm.object.dinnerprice || itm.object.earlycheckin || itm.object.latecheckout) ?
                                    <div className="vb-content">
                                        <div>
                                            <h2>Additions</h2>
                                            <div className="vb-additionals-box">
                                            {itm.object.breakfastprice ?
                                            <div className="vb-checkbox">
                                                <Checkbox item={i} onChange={this.props.onCheckBreakfast} checked={itm.breakfast ? true : false} id={'item_breakfast'+i}/>
                                                <p><label className={"breakfastLabel"+i} htmlFor={'item_breakfast'+i}>Breakfast included</label></p>
                                                <Spinner value={itm.numbreakfast} onChange={this.props.onAddBrekfast} item={i}/>
                                                <span className="additionPrice">Price <span>{itm.object.breakfastprice}kr</span></span>
                                                <span className="additionTotal">Total <span className="totalItemBreakfast">{itm.object.breakfastprice*itm.numbreakfast*itm.breakfast}kr</span></span>
                                            </div>
                                            : ''}
                                            {itm.object.dinnerprice ?
                                            <div className="vb-checkbox">
                                                <Checkbox item={i} onChange={this.props.onCheckDinner} checked={itm.dinner ? true : false} id={'item_dinner'+i}/>
                                                <p><label className={"dinnerLabel"+i} htmlFor={'item_dinner'+i}>Dinner included</label></p>
                                                <Spinner value={itm.numdinner} onChange={this.props.onAddDinner} item={i}/>
                                                <span className="additionPrice">Price <span>{itm.object.dinnerprice}kr</span></span>
                                                <span className="additionTotal">Total <span className="totalItemDinner">{itm.object.dinnerprice*itm.numdinner*itm.dinner}kr</span></span>
                                            </div>
                                            : ''}
                                            {itm.object.earlycheckin ?
                                            <div className="vb-checkbox">
                                                <Checkbox value="1" item={i} onChange={this.props.onCheckEarlyCheckIn} id={'item_early_checkin'+i}/>
                                                <p><label htmlFor={'item_early_checkin'+i}>Early check-in (before 11:00 am)</label></p> 
                                                <span className="additionPrice">Price <span>{itm.object.earlycheckin}kr</span></span>  
                                                <span className="additionTotal">Total <span className="totalItemEarlyCheckin">{itm.object.earlycheckin*itm.earlyCheckIn}kr</span></span>                                     
                                            </div>
                                            : ''}
                                            {itm.object.latecheckout ?
                                            <div className="vb-checkbox">
                                                <Checkbox value="1" item={i} onChange={this.props.onCheckLateCheckOut} id={'item_late_checkout'+i}/>
                                                <p><label htmlFor={'item_late_checkout'+i}>Late check-out (after 2:00 pm) </label></p> 
                                                <span className="additionPrice">Price <span>{itm.object.latecheckout}kr</span></span>   
                                                <span className="additionTotal">Total <span className="totalItemLateCheckout">{itm.object.latecheckout*itm.lateCheckOut}kr</span></span>                                     
                                            </div>
                                            : ''}
                                            </div>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                    : ""}
                                    <div className="vb-order-info">
                                        <div className="vb-top-border">
                                            <h2>Order info</h2>
                                            <div className="order-summary">
                                                <div className="vbmobile-info-content-nights">
                                                    <div className="nightsIcon"></div>
                                                    <div>{itm.dateInterval ? Math.round(itm.dateInterval / 86400 / 1000) : 1}</div>
                                                </div>
                                                {additionalPrice ?
                                                <div className="vbmobile-info-content-additions">
                                                    <div className="additionsIcon"></div>
                                                    <div>{additionalPrice}kr</div>
                                                </div>
                                                : ''}
                                                {(itm.promocode && itm.object.promodiscount) ? 
                                                <div className="vbmobile-info-content-additions">
                                                    <div className="discountIcon"></div>
                                                    <div>{itm.object.promodiscount}kr</div>
                                                </div>
                                                : ''}
                                                <div className="vbmobile-info-total">
                                                    <div className="totalLabel">Total:</div>
                                                    <div>{total}kr</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="vb-ButtonItems">
                                    <button className="vbChangeData" onClick={this.saveAndBack}>Save and back</button>
                                    <button className="vbCart" item={i} onClick={this.onDeleteItem}><span className="icon-trash-white" item={i}></span></button>
                                </div>
                            </div>
                        )
                    }else{
                        return( 
                            <div className="vb-OrderItemsBlock" key={i}>
                                <div className="vb-PhotoItems" style={{'backgroundImage': 'url("'+itm.object.photos[0]+'")'}}>
                                    <p>{itm.object.name}</p>
                                    <span>{total}kr</span>
                                </div>
                                <div className="vb-ContentItems">
                                    <div>
                                        <span className="icon-calendar-grey"></span>
                                        {itm.dateInterval.start.format("MM/DD/YYYY")}
                                    </div>
                                    <div>
                                        <span className="icon-user-grey"></span>
                                        {itm.numPersons}
                                    </div>
                                    <div>
                                        <span className="icon-moon-grey"></span>
                                        {itm.dateInterval ? Math.round(itm.dateInterval / 86400 / 1000) : 1}
                                    </div>
                                    {additionalPrice ?
                                    <div>
                                        <span className="icon-plis-grey"></span>
                                        {additionalPrice}kr
                                    </div>
                                    : ''}
                                    {(itm.promocode && itm.object.promodiscount) ? 
                                    <div>
                                        <span className="icon-label-grey"></span>
                                        {itm.object.promodiscount}kr
                                    </div>
                                    : ''}
                                </div>
                                <div className="vb-ButtonItems">
                                    <button className="vbChangeData" onClick={this.selectObject} item={i}>Change data</button>
                                    <button className="vbCart" item={i} onClick={this.props.onDeleteItem}><span className="icon-trash-white" item={i}></span></button>
                                </div>
                                
                            </div>
                        )
                    }
                }
            )
            return(
                <div>
                    <div className="vb-orderItemsStep">
                        <p>Order ({this.props.items.length} item{this.props.items.length > 1 ? 's' : ''})</p>
                        <div>
                            <span className={this.state.clientInformationEntered ? "icon-cart-green" : "icon-cart-brown"}></span>
                            <span className="icon-damn-gray"></span>
                            <span className={this.state.clientInformationEntered ? "icon-user-green" : "icon-user-grey"}></span>
                            <span className="icon-damn-gray"></span>
                            <span className="icon-checked-grey"></span>
                        </div>
                    </div>

                    {items}

                    {!this.state.selectedObject ? 
                    <div>
                        <button className="vb-EnterYourInformationButton" onClick={this.setClientInformation}>Enter your information</button>

                        <div className="vb-MobileBottomTotal">

                            <div className="vb-mbt-1">
                                <div className="vb-checkbox">
                                    <div><Checkbox id="cart-terms"/></div>
                                    <span><label htmlFor="cart-terms">Confirm terms and conditions</label></span>
                                </div>
                                <div className="vb-checkbox">
                                    <div><Checkbox id="cart-subscribe"/></div>
                                    <span><label htmlFor="cart-subscribe">Subscribe to newsletters</label></span>
                                </div>
                                <button className="vb-backtosearch" onClick={this.props.onBackToSearch}>back to search</button>
                            </div>

                            <div className="vb-mbt-2">
                                <p>enter discount code</p>
                                <div>
                                    <input type="text" placeholder="Code" defaultValue={this.props.promocode} onChange={this.props.onUpdatePromoCode}/>
                                    <input type="submit" value="" onClick={this.props.onRecalculatePrice} readOnly/>
                                </div>
                                    <div className="vb-totalMb">
                                        <span>Total:</span>
                                        <span>{totalCartAmt}kr</span>
                                    </div>
                            </div>

                        </div>

                        <button className="vb-EnterYourInformationButton">Go to payment</button>
                    </div>            
                    : ''}
                    
                </div>
            )
        }else if(this.state.displayMode === 1){
            return(
                <div className="clientInfo">
                    <div className="vb-orderItemsStep">
                        <p>Enter your information </p>
                        <div>
                            <span className="icon-cart-green"></span>
                            <span className="icon-damn-gray"></span>
                            <span className="icon-user-brown"></span>
                            <span className="icon-damn-gray"></span>
                            <span className="icon-checked-grey"></span>
                        </div>
                    </div>
                    <div className="vb-EnterYourInformationBox">
                        <h2>Information:</h2>

                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="text" defaultValue={this.props.client.FirstName} placeholder="First Name" onBlur={this.props.onEditClientFirstName}/>
                                {this.props.client.FirstName ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="text" defaultValue={this.props.client.LastName} placeholder="Last Name" onBlur={this.props.onEditClientLastName}/>
                                {this.props.client.LastName ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="email" defaultValue={this.props.client.Email} placeholder="E-mail" onBlur={this.props.onEditClientEmail}/>
                                <button>Send a code</button>
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="text" defaultValue={this.props.client.Code} placeholder="Code" onBlur={this.props.onEditClientCode}/>
                                {this.props.client.Code ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="text" defaultValue={this.props.client.Company} placeholder="Company" onBlur={this.props.onEditClientCompany}/>
                                {this.props.client.Company ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="tel" defaultValue={this.props.client.Phone} placeholder="Phone" onBlur={this.props.onEditClientPhone}/>
                                {this.props.client.Phone ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <h2>Your location:</h2>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="text" defaultValue={this.props.client.Zip} placeholder="Zip-code" onBlur={this.props.onEditClientZip}/>
                                {this.props.client.Zip ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">                            
                                <Dropdown
                                        value={this.props.client.Country} 
                                        options={countriesOptions}                                    
                                        placeholder='Country'
                                        name="country"
                                        className="vb-select-rooms"
                                        onChange={this.props.onEditClientCountry}
                                />                        
                                {this.props.client.Country ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="text" defaultValue={this.props.client.Nationality} placeholder="Nationality" onBlur={this.props.onEditClientNationality}/>
                                {this.props.client.Nationality ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="text" defaultValue={this.props.client.City} placeholder="City" onBlur={this.props.onEditClientCity}/>
                                {this.props.client.City ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <div className="vb-information-order3items-box">
                            <div className="vb-information-order3items-block">
                                <input type="text" defaultValue={this.props.client.Address} placeholder="Address" onBlur={this.props.onEditClientAddress}/>
                                {this.props.client.Address ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>
                        <h2>Notes:</h2>
                        <div className="vb-information-order3items-box textarea-container">
                            <div className="vb-information-order3items-block textarea-block">
                                <textarea defaultValue={this.props.client.Notes} onBlur={this.props.onEditClientNotes}/>
                                {this.props.client.Notes ? 
                                <span className="greenCheckBox"></span>
                                : ''}
                            </div>
                        </div>

                    </div>
                    <button className="vb-EnterYourInformationButton" onClick={this.saveClientInformation}>Fill your information</button>
                </div>
            )
        }
    }
}

export default MobileCart;